// The viewer kinds whose stored form is a file someone can open, so a pane
// showing one offers Download (.claude/features/12881-preview-download-ux.md).
// OneNote pages, Teams posts, eVestment notes and agent notes are left out:
// what is stored for them is an internal JSON envelope. Every pane that
// previews a document reads this one list, so they cannot disagree.
const DOWNLOADABLE_KINDS: ReadonlySet<string> = new Set([
  "pdf",
  "excel",
  "csv",
  "artifact", // Chart sources (Excel blobs)
  "docx",
  "pptx",
  // The stored .msg/.eml (`raw` skips the viewer's JSON conversion).
  "email",
  "finpilot-interaction",
  "altvia_interaction",
  "altvia_interaction_note",
  "html",
  "markdown",
  "unsupported",
  // The stored bytes, whatever they are, are still the user's file.
  "unreadable",
]);

export const isDownloadableKind = (kind: string | null | undefined): boolean =>
  kind != null && DOWNLOADABLE_KINDS.has(kind);
